import React from "react";
import { motion } from "framer-motion";
import { FiExternalLink, FiCpu, FiEye } from "react-icons/fi";
import "./Styles.css";

const research = [
    {
        icon: <FiEye />,
        kicker: "Final Year Project",
        name: "Psychiatric Patient Behaviour Detection",
        description:
            "An alerting system that analyzes video of psychiatric patients using LSTM, converts behaviour to text, runs it through a sentiment analyzer to judge harmfulness, and alerts health personnel. Built the dataset from scratch as none existed for this sensitive domain.",
        tags: ["Python", "NLP", "LSTM", "React Native", "Socket.io", "Node.js"],
    },
    {
        icon: <FiCpu />,
        kicker: "AI / Deep Learning",
        name: "Drowsiness Detection & Alert System",
        description:
            "A CNN-based model that detects sleepy-eye and yawning patterns from video and alerts the user in real time. Built and preprocessed my own dataset, optimized with early stopping.",
        tags: ["Python", "Deep Learning", "CNN", "Tkinter"],
    },
];

const projects = [
    {
        link: "https://trackingcrypto.netlify.app",
        name: "Crypto Tracker",
        description:
            "Live cryptocurrency dashboard tracking real-time prices and trends via the CoinGecko API.",
        img: "crypt.png",
        tags: ["React", "CoinGecko API"],
    },
    {
        link: "https://ourecomsite.netlify.app",
        name: "Ecommerce Site",
        description:
            "A shopping experience with product listings and cart flow, built in React.",
        img: "ecom.png",
        tags: ["React", "CSS"],
    },
    {
        link: "https://brainquizapp.netlify.app",
        name: "Quiz Site",
        description:
            "An interactive quiz app that keeps score while you test your knowledge.",
        img: "quiz.png",
        tags: ["React", "JavaScript"],
    },
    {
        link: "https://knowbooks.netlify.app",
        name: "Books Site",
        description:
            "Browse and discover books, powered by a public books API.",
        img: "book.png",
        tags: ["React", "API"],
    },
    {
        link: "https://qrcodeisgenerated.netlify.app",
        name: "QR Code Generator",
        description:
            "Turns any text or link into a scannable QR code in one click.",
        img: "qr.png",
        tags: ["React", "API"],
    },
    {
        link: "https://tooday.netlify.app",
        name: "To-Do List",
        description: "A clean, focused to-do app for organizing daily tasks.",
        img: "todo.png",
        tags: ["React", "CSS"],
    },
];

const Project = () => {
    return (
        <section className="section" id="projectdiv">
            <motion.h2
                className="section-title"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
            >
                <span className="section-number">04.</span> Things I've Built
            </motion.h2>

            <div className="research-grid">
                {research.map((item, i) => (
                    <motion.div
                        key={item.name}
                        className="research-card"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.55, delay: i * 0.12 }}
                    >
                        <div className="research-icon">{item.icon}</div>
                        <p className="featured-kicker">{item.kicker}</p>
                        <h3>{item.name}</h3>
                        <p className="research-desc">{item.description}</p>
                        <div className="project-tags">
                            {item.tags.map((tag) => (
                                <span key={tag}>{tag}</span>
                            ))}
                        </div>
                    </motion.div>
                ))}
            </div>

            <motion.p
                className="subheading"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
            >
                Personal Projects
            </motion.p>

            <div className="projects-grid">
                {projects.map((currel, i) => (
                    <motion.a
                        key={currel.name}
                        className="project-card"
                        href={currel.link}
                        target="_blank"
                        rel="noreferrer"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: (i % 3) * 0.1 }}
                    >
                        <div className="project-thumb">
                            <img
                                src={currel.img}
                                alt={currel.name}
                                loading="lazy"
                            />
                        </div>
                        <div className="project-body">
                            <div className="project-titlerow">
                                <h3>{currel.name}</h3>
                                <FiExternalLink className="project-linkicon" />
                            </div>
                            <p>{currel.description}</p>
                            <div className="project-tags">
                                {currel.tags.map((tag) => (
                                    <span key={tag}>{tag}</span>
                                ))}
                            </div>
                        </div>
                    </motion.a>
                ))}
            </div>
        </section>
    );
};

export default Project;
